import type { ReactElement, ReactNode } from 'react'
import { Check, AlertTriangle } from 'lucide-react'

interface Props {
  icon: ReactNode
  label: string
  value: string
  status: 'ok' | 'warn'
  onOverride: () => void
}

export const ScanResultRow = ({ icon, label, value, status, onOverride }: Props): ReactElement => (
  <div className="flex items-start gap-3 py-3 border-b border-border last:border-0">
    <div className="w-9 h-9 rounded-full bg-accent text-accent-foreground flex items-center justify-center shrink-0 text-base">
      {icon}
    </div>
    <div className="flex-1 min-w-0">
      <div className="font-semibold text-foreground">{label}</div>
      <div className="text-sm text-muted-foreground">{value}</div>
    </div>
    <div className="flex flex-col items-end gap-1.5">
      <button
        type="button"
        onClick={onOverride}
        className="text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
      >
        Edit
      </button>
      <span
        className={
          status === 'ok'
            ? 'w-5 h-5 rounded-full bg-[color:var(--color-ok-500)]/15 text-[color:var(--color-ok-500)] flex items-center justify-center'
            : 'w-5 h-5 rounded-full bg-[color:var(--color-warn-500)]/15 text-[color:var(--color-warn-500)] flex items-center justify-center'
        }
        aria-label={status === 'ok' ? 'verified' : 'check value'}
      >
        {status === 'ok' ? <Check className="h-3 w-3" /> : <AlertTriangle className="h-3 w-3" />}
      </span>
    </div>
  </div>
)
